import axios from "axios"


//const
const ENTERPRISE_DETAILS_GET_INFO = "editEnterpriseDetails/ENTERPRISE_DETAILS_GET_INFO"
const ENTERPRISE_DETAILS_UPDATE = "editEnterpriseDetails/ENTERPRISE_DETAILS_UPDATE"
const REPRE_LICENSE_TYPE_GET = "editEnterpriseDetails/REPRE_LICENSE_TYPE_GET"
const PROFESSION_GET = "editEnterpriseDetails/PROFESSION_GET"
const PROPERTY_GET = "editEnterpriseDetails/PROPERTY_GET"
const SCALE_GET = "editEnterpriseDetails/SCALE_GET"
const REPRE_LICENSE_LOCATION_GET = "editEnterpriseDetails/REPRE_LICENSE_LOCATION_GET"
// const PROVINCE_GET = "editEnterpriseDetails/PROVINCE_GET"
// const CITY_GET = "editEnterpriseDetails/CITY_GET"
// const DISTRICT_GET = "editEnterpriseDetails/DISTRICT_GET"
// const GET_ALL_CITIES = "editEnterpriseDetails/GET_ALL_CITIES"
// const GET_ALL_DISTRICTS = "editEnterpriseDetails/GET_ALL_DISTRICTS"
const REGION_GET = "editEnterpriseDetails/REGION_GET"
const REGION_ARRAY_GET = "editEnterpriseDetails/REGION_ARRAY_GET"

//reducer
export const editEnterpriseDetails = (state = {
  regions:[],
  // provinces: [],
  // cities: [],
  // districts: [],
  repreLicenseLocations: [],
  scales: [],
  properties: [],
  professions: [],
  repreLicenseTypes: [],
  region:"",
  regionArray:[],
  enterpriseinfo: {
    name: "",
    id:"",
    alias: "",
    province: "",
    city: "",
    district: "",
    address: "",
    profession: "",
    property: "",
    scale: "",
    metadata: "",
    unifiedCreditId: "",
    businessExpiryDate: "",
    licenseImage: "",
    bankName: "",
    taxpayerNum: "",
    bankAccountName: "",
    bankAccountNum: "",
    repreLicenseLocation: "",
    repreName: "",
    repreLicenseType: "",
    repreLicenseNum: "",
    repreLicenseExpiryDate: "",
    repreLicenseFrontImage: "",
    repreLicenseBackImage: "",
    logo:"",
  }
}, action) => {
  switch (action.type) {
    case ENTERPRISE_DETAILS_GET_INFO: {
      console.log("debug: ", action.data)
      let newEnterpriseInfo = {
        name: action.data.enterprise.name,
        id:action.data.enterprise.id,
        alias: action.data.enterprise.alias,
        province: action.data.province,
        city: action.data.city,
        district: action.data.district,
        address: action.data.address,
        profession: action.data.profession,
        property: action.data.property,
        scale: action.data.scale,
        metadata: action.data.metadata,
        unifiedCreditId: action.data.unifiedCreditId,
        businessExpiryDate: action.data.businessExpiryDate,
        licenseImage: action.data.licenseImage,
        bankName: action.data.bankName,
        taxpayerNum: action.data.taxpayerNum,
        bankAccountName: action.data.bankAccountName,
        bankAccountNum: action.data.bankAccountNum,
        repreLicenseLocation: action.data.repreLicenseLocation,
        repreName: action.data.repreName,
        repreLicenseType: action.data.repreLicenseType,
        repreLicenseNum: action.data.repreLicenseNum,
        repreLicenseExpiryDate: action.data.repreLicenseExpiryDate,
        repreLicenseFrontImage: action.data.repreLicenseFrontImage,
        repreLicenseBackImage: action.data.repreLicenseBackImage,
        logo: action.data.logo,

      }
      return {
        ...state,
        enterpriseinfo: newEnterpriseInfo
      }
    };
    case ENTERPRISE_DETAILS_UPDATE:
      return {
        ...state,
        enterpriseinfo: {
          ...state.enterpriseinfo,
          [action.data.name]: action.data.value
        }
      };

    case REPRE_LICENSE_TYPE_GET:
      console.log("Type: ", action.data._embedded.repreLicenseTypes)
      return {
        ...state,
        repreLicenseTypes: action.data._embedded.repreLicenseTypes

      };

    case PROFESSION_GET:
      console.log("PROFESSION: ", action.data._embedded.professions)
      return {
        ...state,
        professions: action.data._embedded.professions

      };

    case PROPERTY_GET:
      console.log("PROPERTY: ", action.data._embedded.properties)
      return {
        ...state,
        properties: action.data._embedded.properties

      };

    case SCALE_GET:
      console.log("SCALE: ", action.data._embedded.scales)
      return {
        ...state,
        scales: action.data._embedded.scales

      };

    case REPRE_LICENSE_LOCATION_GET:
      console.log("REPRELICENSELOCATION: ", action.data._embedded.repreLicenseLocations)
      return {
        ...state,
        repreLicenseLocations: action.data._embedded.repreLicenseLocations

      };

    // case PROVINCE_GET:
    //   console.log("PROVINCE: ", action.data._embedded.provinces)
    //   return {
    //     ...state,
    //     provinces: action.data._embedded.provinces
    //
    //   };
    //
    // case CITY_GET:
    //   console.log("CITY: ", action.data._embedded.cities)
    //   return {
    //     ...state,
    //     cities: action.data._embedded.cities
    //
    //   };
    //
    // case DISTRICT_GET:
    //   console.log("DISTRICT: ", action.data._embedded.districts)
    //   return {
    //     ...state,
    //     districts: action.data._embedded.districts
    //
    //   };
    //
    // case GET_ALL_CITIES: {
    //   console.log("allcities", action.data)
    //   return {
    //     ...state,
    //     cities: action.data
    //   }
    // }
    //
    // case GET_ALL_DISTRICTS: {
    //   return {
    //     ...state,
    //     districts: action.data
    //   }
    // }

    case REGION_GET:
      console.log("REGIONS: ", action.data.content);
      return {
        ...state,
        regions:action.data.content.map(region => {
          region.label = region.name;
          region.value = region.code;
          region.children.map(city => {
            city.label = city.name;
            city.value = city.code;
            city.children.map(district => {
              district.label = district.name;
              district.value = district.code;
              return district;
            });
            return city;
            });
          return region;
        })
    }

    case REGION_ARRAY_GET:
      console.log("regionArray", action.data)
      return {
        ...state,
        regionArray: action.data
    }
    default:
      return state
  }
}

// action
export const getEnterpriseDetails = (id) => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  let url = "/api-user/enterpriseInfoes?id=" + id;

  return axios({
    method: "GET",
    url: url,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("enterprise", response.data);
        dispatch(getEnterpriseDetailsDone(response.data))
      }
      axios({
        method: "GET",
        url: "/api-user/getRegion?provinceName="+response.data.province+"&cityName="+response.data.city+"&districtName="+response.data.district,
        contentType: "application/json",
      }).then(
        response => {
          dispatch(getRegionArrayDone(response.data))
        }
      )
    })
}

export const getRegionArrayDone = (data) => {
  return {
    type: REGION_ARRAY_GET,
    data: data
  }
};

export const getRepreLicenseType = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/repreLicenseTypes`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("response", response.data);
        dispatch(getRepreLicenseTypeDone(response.data))
      }
    })
}



export const getProfession = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/professions`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("profession", response.data);
        dispatch(getProfessionDone(response.data))
      }
    })
}

export const getProperty = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/properties`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("property", response.data);
        dispatch(getPropertyDone(response.data))
      }
    })
}

export const getPropertyDone = (data) => {
  return {
    type: PROPERTY_GET,
    data: data
  }
};

export const getScale = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/scales`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("scale", response.data);
        dispatch(getScaleDone(response.data))
      }
    })
}

export const getRepreLicenseLocation = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/repreLicenseLocations`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("repreLicenseLocation", response.data);
        dispatch(getRepreLicenseLocationDone(response.data))
      }
    })
}

// export const getProvince = () => (dispatch) => {
//
//   let myHeaders = new Headers()
//   myHeaders.append("Content-Type", "application/json")
//
//   return axios({
//     method: "GET",
//     url: `/api-user/provinces`,
//     contentType: "application/json",
//   }).then(
//     response => {
//       if (response.status === 200) {
//         console.log("provinces", response.data);
//         dispatch(getProvinceDone(response.data))
//       }
//     })
// }
//
// export const getCity = () => (dispatch) => {
//
//   let myHeaders = new Headers()
//   myHeaders.append("Content-Type", "application/json")
//
//   return axios({
//     method: "GET",
//     url: `/api-user/cities`,
//     contentType: "application/json",
//   }).then(
//     response => {
//       if (response.status === 200) {
//         console.log("cities", response.data);
//         dispatch(getCityDone(response.data))
//       }
//     })
// }
//
// export const getDistrict = () => (dispatch) => {
//
//   let myHeaders = new Headers()
//   myHeaders.append("Content-Type", "application/json")
//
//   return axios({
//     method: "GET",
//     url: `/api-user/districts`,
//     contentType: "application/json",
//   }).then(
//     response => {
//       if (response.status === 200) {
//         console.log("districts", response.data);
//         dispatch(getDistrictDone(response.data))
//       }
//     })
// }

export const getRegion = () => (dispatch) => {

  let myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  return axios({
    method: "GET",
    url: `/api-user/getProvinces?name=&pageNumber=0&pageSize=200`,
    contentType: "application/json",
  }).then(
    response => {
      if (response.status === 200) {
        console.log("regions", response.data);
        dispatch(getRegionDone(response.data))
      }
    })
}


export const getRegionDone = (data) => {
  return {
    type: REGION_GET,
    data: data
  }
};

// export const getDistrictDone = (data) => {
//   return {
//     type: DISTRICT_GET,
//     data: data
//   }
// };
//
// export const getCityDone = (data) => {
//   return {
//     type: CITY_GET,
//     data: data
//   }
// };
//
// export const getProvinceDone = (data) => {
//   return {
//     type: PROVINCE_GET,
//     data: data
//   }
// };

export const getRepreLicenseLocationDone = (data) => {
  return {
    type: REPRE_LICENSE_LOCATION_GET,
    data: data
  }
};

export const getScaleDone = (data) => {
  return {
    type: SCALE_GET,
    data: data
  }
};

export const getProfessionDone = (data) => {
  return {
    type: PROFESSION_GET,
    data: data
  }
};

export const getRepreLicenseTypeDone = (data) => {
  return {
    type: REPRE_LICENSE_TYPE_GET,
    data: data
  }
};

export const getEnterpriseDetailsDone = (data) => {
  return {
    type: ENTERPRISE_DETAILS_GET_INFO,
    data: data
  }
};

export const updateData = (data) => {
  return {
    type: ENTERPRISE_DETAILS_UPDATE,
    data: data
  }
};

// export const getAllCities = (province) => (dispatch) => {
//   return axios({
//     method: "GET",
//     url: `/api-user/cities/search/provinceName?provinceName=${province}`
//   }).then(
//     response => {
//       dispatch(getAllCitiesDone(response.data._embedded.cities))
//     }
//   )
// }
//
// export const getAllCitiesDone = (cities) => {
//   return {
//     type: GET_ALL_CITIES,
//     data: cities
//   }
// }
//
// export const getAllDistricts = (city) => (dispatch) => {
//   return axios({
//     method: "GET",
//     url: `/api-user/districts/search/cityName?cityName=${city}`
//   }).then(
//     response => {
//       dispatch(getAllDistrictsDone(response.data._embedded.districts))
//     }
//   )
// }
//
// export const getAllDistrictsDone = (districts) => {
//   return {
//     type: GET_ALL_DISTRICTS,
//     data: districts
//   }
// }
